import React, { Fragment, useContext, useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { Icon, Input, Password, Radio } from "@app/components";
import {
  MonthList,
  yearsList,
  emailPattern,
  gradesList,
  stateList,
  passwordPattern,
  childPlayOptions,
  perferneceOptions,
  subjectOptionsInclAll,
  allSubjectOptions,
  subscriptionOptions,
  capitalize,
  ALPHA_NUMERIC,
  USERNAME_CHAR_COUNT 
} from "@app/utils";
import {
  FormFlexWrapper,
  DropdownWrapper,
  Error,
  SelectCustomStyles,
  FlexWrapper,
  CommonLabel,
  EmptyContainer,
  DefaultMessage,
} from "@app/components/commonStyles";
import { generateStudentPassword, generateStudentUsername, getAddress } from "@app/services";
import { SubBox } from "./addChild-component";
import { AuthContext } from "@app/providers";
type Props = {
  selectedTab: number;
  register: any;
  errors: any;
  control: any;
  getValues: (e: any) => any;
  setValue: any;
  trigger: any;
  watch: any;
  zipError: boolean;
  setZipError: (e: any) => void;
  childPassword: any;
  childUsername: any;
  clearErrors: any;
  toastErr: any
  userDetails: any;
  spinner: boolean;
};

export default function AddChildContent({
  selectedTab,
  register,
  errors,
  control,
  getValues,
  trigger,
  watch,
  setValue,
  zipError,
  setZipError,
  clearErrors,
  childPassword,
  childUsername,
  toastErr,
  userDetails,
  spinner
}: Props) {
  function onPasswordBlur() {
    if (getValues("confirmPassword")) {
      trigger("confirmPassword");
    }
  }

  const selectedState: any = stateList.find(
    (state) => state.value === userDetails.state
  );
  const { userInfo, setUserInfo } = useContext(AuthContext);
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  const userToken = userInfo && userInfo.sessionToken;
  const [studentPassword, setStudentPassword] = useState<any>('');
  const [studentUsername, setStudentUsername] = useState<any>('');
  const [studentInputDatas, setStudentInputDatas] = useState<any>('');
  const [inputValue, setInputValue] = useState('');
  
  const [showToast, setShowToast] = React.useState(false);
  // useEffect(()=>{
  // setValue("state",userDetails.state)                                            
  // },[])

  const [modifiedList, setModifiedList] = useState([
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ])
  const [childMonth, SetChildMonth] = useState<any>([])
  const [childYear, setChildYear] = useState<any>()
  const [childSubject, setChildSubject] = useState<any>()
  const [disableMonth, setDisableMonth] = useState<boolean>(true)
  const Year = new Date().getFullYear()
  const base64 = require('base-64');

  useEffect(() => {
    const Month = new Date().getMonth() + 1;
    modifiedList.map((month: any) => {
      if (month.value <= Month) {
        childMonth.push(month)
      }
    })
    if(userDetails.childPassword){
      setStudentPassword(userDetails.childPassword);
    }
    if(userDetails.childUsername){
      setStudentUsername(userDetails.childUsername);
    }
    if(userDetails.childInputDatas){
      setStudentInputDatas(userDetails.childInputDatas);
    }
  }, [userDetails])


  const [serverZipErr, setServerZipErr] = useState('')
  function onZipBlur(data: any) {
    setServerZipErr('')
    if (data.target.value.length !== 5) {
      setZipError(true);
      return;
    }
    setZipError(false);
    getAddress(data.target.value)
      .then((res) => {
        if (res && !res.error) {
          setValue("city", capitalize(res.city));
          clearErrors("city");
          const selectedState = stateList.find(
            (state) => state.value === res.state
          );
          setValue("state", selectedState);
          clearErrors("state");
        }
        else {
          setServerZipErr(res.error)
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const onYearChange = (e: any) => {
    setValue("birthYear", e)
    setValue("birthMonth", '')
    setChildYear(e.value)
    if (e) {
      setDisableMonth(false)
    } else {
      setDisableMonth(true)
    }

    // if (e.value == Year) {
    //   const Month = new Date().getMonth() + 1;
    //   modifiedList.map((month: any) => {
    //     if (month.value <= Month) {
    //       childMonth.push(month.label)
    //     }

    //   })
    // } else {
    //   childMonth.push(modifiedList)
    // }
 
  }

  const onSubjectChange = (e: any) => {
    setValue("subject", e)
    e && e.value && setChildSubject(e.value)
    e && e.forEach((option: any) => {
      if(option.value === "all") {
        setValue("subject", allSubjectOptions)
        setChildSubject(allSubjectOptions)
      }
    });
    
  }
  
  useEffect(() => {
    //  const subscription = 
    watch("birthYear", ({ name, type }: any) => ''
    );
    //if(subscription)
    // return () => subscription.unsubscribe();
  }, []);

  function generatePassword() {
    const params: any = {};
    Object.assign(params, {
      sessionToken: userToken,
      userId: userInfo && userInfo.userJson.userId,
      update: 0
    });
    generateStudentPassword(params)
      .then((res: any) => {
        const response = res;
        if (response._responseStatus === 1) {
          let childPass = base64.decode(response.studentPassword);
          setStudentPassword(childPass);
          childPassword(childPass);
          setToastMessage({
            type: "success",
            message: "Student Password updated Successfully",
          });
          setShowToast(true);
        }
        else {
          setToastMessage({
            type: "error",
            message: "Failed to reset Password",
          });
          setShowToast(true);
        }
      })
      .catch((err) => {
        console.log(err)
        setToastMessage({
          type: "error",
          message: "Something went wrong",
        });
        setShowToast(true);
      })
  }

  function generateUsername() {
    const alphanumeric = ALPHA_NUMERIC;
    let randomUsername = "";
    for (let i = 0; i < USERNAME_CHAR_COUNT; i++) {
      const randomChar = alphanumeric[Math.floor(Math.random() * alphanumeric.length)];
      randomUsername += randomChar;
    }
    let childUsername = randomUsername;
    setStudentUsername(childUsername);
    //childUsername(childUsername);
    setToastMessage({
      type: "success",
      message: "Student username updated Successfully",
    });
    setShowToast(true);
  }

  return (
    <>
      {selectedTab === 1 && (
        <Fragment>
          <FormFlexWrapper className="two-child-layout mb-0">
            <div className="child mb-0">
              <Input
                label="First Name"
                placeholder="First Name"
                name="firstName"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.firstName && "Please enter First Name"}
              />
            </div>
            <div className="child">
              <Input
                label="Last Name"
                placeholder="Last Name"
                name="lastName"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.lastName && "Please enter Last Name"}
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="two-child-layout mb-0">
            <div className="child mb-0">
              <DropdownWrapper>
                <CommonLabel className="label-color">Birth Year</CommonLabel>
                <Controller
                  value="value"
                  name="birthYear"
                  options={yearsList}
                  render={({ onChange, value }: any) => (
                    <Select
                      isSearchable={false}
                      options={yearsList}
                      onChange={onYearChange}
                      styles={SelectCustomStyles}
                      selected={value}
                      placeholder="Birth Year"
                      menuPosition={"fixed"}
                      value={value}
                    />
                  )}
                  control={control}
                  rules={{ required: true }}
                  defaultValue={""}
                />
                {errors.birthYear && <Error>Please select Birth Year</Error>}
              </DropdownWrapper>
            </div>
            <div className="child">
              <DropdownWrapper className={disableMonth ? 'disabled' : ''}>
                <CommonLabel className="label-color">Birth Month</CommonLabel>
                <Controller
                  as={<Select isSearchable={false} />}
                  value="value"
                  name="birthMonth"
                  options={childYear === Year ? childMonth : MonthList}
                  placeholder="Birth Month"
                  disabled={disableMonth}
                  control={control}
                  rules={{ required: true }}
                  styles={SelectCustomStyles}
                  defaultValue={""}
                  menuPosition={"fixed"}
                  className="month"
                />
                {errors.birthMonth && <Error>Please select Birth Month</Error>}
              </DropdownWrapper>
            </div>
          </FormFlexWrapper>

          <FormFlexWrapper className="two-child-layout mb-0">
            <div className="child">
              <CommonLabel className="label-color">Grade</CommonLabel>
              <DropdownWrapper>
                <Controller
                  as={<Select isSearchable={false} />}
                  value="value"
                  name="grade"
                  options={gradesList}
                  placeholder="Grade"
                  control={control}
                  rules={{ required: true }}
                  styles={SelectCustomStyles}
                  defaultValue={""}
                  menuPosition={"fixed"}
                />
                {errors.grade && <Error>Please select Grade</Error>}
              </DropdownWrapper>
            </div>
          </FormFlexWrapper>
        </Fragment>     
      )}
      {selectedTab === 2 && (
        <Fragment>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <p className="username-label" style={{ marginBottom: "10px" }} >Username </p>
              <Input
                type="text"
                placeholder="Username"
                name="email"
                value={studentUsername}
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
              />
              {errors.email && <Error>Please Enter Username</Error>}
            </div>
          </FormFlexWrapper>
          
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <p className="anchor-tag" onClick={() => generatePassword()} style={{ marginBottom: "10px" }} >Password </p>
              <Password
                placeholder="Password"
                name="password"
                showInfo={false}
                showInstructions={false}
                hideIcon={true}
                defaultPasswordvisiblility={true}
                value={studentPassword}
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
              />
              {errors.password && <Error>Please Enter Password</Error>}
            </div>
          </FormFlexWrapper>
          {spinner &&
                    <EmptyContainer>
                      <Icon name="loader" />
                      <DefaultMessage>Loading, please wait...</DefaultMessage>
                    </EmptyContainer>
          }
        </Fragment>
      )
      }
      {
        selectedTab === 3 && (
          <Fragment>
            <FormFlexWrapper>
              <div className="child only-child">
                <CommonLabel>Who can my child play with?</CommonLabel>
                {childPlayOptions.map((each: any) => (
                  <Radio
                    className="radio"
                    name="childPlayOption"
                    value={each.id}
                    key={each.id}
                    checked={true}
                    register={register({
                      required: true,
                    })}
                    id={"play_" + each.id}
                    label={each.label}
                    disable
                  />
                ))}
                {errors.childPlayOption && (
                  <Error>Please select Child Play Option</Error>
                )}
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper>
              <div className="child only-child">
                <CommonLabel>Level Preference?</CommonLabel>
                <FlexWrapper>
                  {perferneceOptions.map((each: any) => (
                    <Radio
                      className="radio mr-3"
                      name="levelPreference"
                      value={each.id}
                      key={each.id}
                      checked={true}
                      register={register({
                        required: true,
                      })}
                      id={"level_" + each.id}
                      label={each.label}
                      disable
                    />
                  ))}
                </FlexWrapper>
                {errors.levelPreference && (
                  <Error>Please select Level Preference</Error>
                )}
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <DropdownWrapper>
                  <CommonLabel>
                    Subjects I'd like my child to explore?
                  </CommonLabel>
                  <Controller
                  value="value"
                  name="subject"
                  options={subjectOptionsInclAll}
                  placeholder="Select Subjects"
                  control={control}
                  styles={SelectCustomStyles}
                  render={({ onChange, value }: any) => (
                    <Select
                      isSearchable={false}
                      options={subjectOptionsInclAll}
                      onChange={onSubjectChange}
                      styles={SelectCustomStyles}
                      placeholder="Subject"
                      menuPosition={"fixed"}
                      isMulti={true}
                      value={value}
                      selected={value}
                      closeMenuOnSelect={false}
                    />
                  )}
                  rules={{ required: true }}
                  defaultValue={""}
                />
                  {errors.subject && (
                    <Error>Please select atleast one Subject</Error>
                  )}
                </DropdownWrapper>
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper>
              <div className="child only-child">
                <CommonLabel>Subscription Plans</CommonLabel>
                <SubBox>
                  <FlexWrapper>
                    {subscriptionOptions.map((each: any) => (
                      <Radio
                        className="radio"
                        name="subscriptionOption"
                        value={each.id}
                        key={each.id}
                        checked={true}
                        register={register({
                          required: true,
                        })}
                        id={"plan_" + each.id}
                        label={each.label}
                      />
                    ))}
                  </FlexWrapper>
                </SubBox>
              </div>
            </FormFlexWrapper>
          </Fragment>
        )
      }
    </>
  );
}
